import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import formatUtcToLocalDate from 'utils/formatUtcToLocalDate';

import dateFormat from 'config/dateFormat';
import timeDateFormat from 'config/timeDateFormat';

const styles = () => ({
  cellName: {
    wordWrap: 'break-word',
    wordBreak: 'break-all',
  },
  cellSize: {
    whiteSpace: 'nowrap',
  },
  cellDate: {
    whiteSpace: 'nowrap',
  },
});

const PatientsDialogDocumentsListItem = ({ onClick, business, classes, ...otherProps }) => (
  <TableRow
    hover
    {...onClick ? {
      onClick,
      onKeyDown: (event) => {
        if (event.key === 'Enter') {
          onClick();
        }
      },
      tabIndex: 0,
    } : {}}
  >
    <TableCell className={classes.cellName}>
      {otherProps['File Name']}
    </TableCell>
    <TableCell className={classes.cellSize}>
      {otherProps['File Size']}
    </TableCell>
    <TableCell className={classes.cellDate}>
      {formatUtcToLocalDate(
        otherProps['Create At'],
        timeDateFormat,
        dateFormat,
        business['Company Address']['Time Zone'],
        business['Company Address']['Observes Daylight Saving'],
      )}
    </TableCell>
  </TableRow>
);

PatientsDialogDocumentsListItem.propTypes = {
  'File Name': PropTypes.string.isRequired,
  'Create At': PropTypes.string.isRequired,
  'File Size': PropTypes.string.isRequired,
  onClick: PropTypes.func,
  business: PropTypes.shape({
    ID: PropTypes.number,
    'Time Zone': PropTypes.string,
  }),
  classes: PropTypes.shape({
    cellName: PropTypes.string.isRequired,
    cellSize: PropTypes.string.isRequired,
    cellDate: PropTypes.string.isRequired,
  }).isRequired,
};

PatientsDialogDocumentsListItem.defaultProps = {
  onClick: null,
  business: {},
};

export default withStyles(styles)(PatientsDialogDocumentsListItem);



// WEBPACK FOOTER //
// ./src/components/patient/PatientsDialog/PatientsDialogDocumentsListItem.js